"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var LftHelper_1 = __importDefault(require("../LftHelper"));
var chevron_up_1 = __importDefault(require("@lift/assets/dist/assets/globals/icons/chevron_up"));
var chevron_down_1 = __importDefault(require("@lift/assets/dist/assets/globals/icons/chevron_down"));
var use_key_press_1 = require("../../utils/hooks/use-key-press");
var LftIconBase_1 = __importDefault(require("../LftIconBase"));
var LftListMenu_1 = __importDefault(require("../LftListMenu"));
var S = __importStar(require("./LftInputSelect.styles"));
var LftInputSelect = function (_a) {
    var _b, _c, _d, _e;
    var bgColor = _a.bgColor, children = _a.children, dataElement = _a.dataElement, dataInfo = _a.dataInfo, dataTestId = _a.dataTestId, disabled = _a.disabled, helper = _a.helper, _f = _a.helperText, helperText = _f === void 0 ? 'HelperText' : _f, _g = _a.id, id = _g === void 0 ? 'selectId' : _g, label = _a.label, _h = _a.name, name = _h === void 0 ? 'selectName' : _h, _j = _a.placeholder, placeholder = _j === void 0 ? 'Select' : _j, _k = _a.status, status = _k === void 0 ? 'default' : _k, _l = _a.tabIndex, tabIndex = _l === void 0 ? 0 : _l, _m = _a.value, value = _m === void 0 ? '' : _m, lftBlur = _a.lftBlur, lftChange = _a.lftChange, lftClick = _a.lftClick, lftFocus = _a.lftFocus;
    var selectBox = (0, react_1.createRef)();
    var escapePress = (0, use_key_press_1.useKeyPress)('Escape', selectBox);
    var _o = (0, react_1.useState)(false), opened = _o[0], setOpened = _o[1];
    var _p = (0, react_1.useState)(null), index = _p[0], setIndex = _p[1];
    var handleBlur = function (isOutside) {
        if (isOutside === void 0) { isOutside = false; }
        (!opened || isOutside) && !!lftBlur && lftBlur();
    };
    var handleFocus = function (e) {
        !opened && !!lftFocus && lftFocus(e);
    };
    (0, react_1.useEffect)(function () {
        react_1.Children.map(children, function (child, index) {
            if (child && value) {
                if (child.props.value === value) {
                    setIndex(index);
                }
            }
            else {
                setIndex(null);
            }
        });
    }, [value]);
    var _handleClickOutside = function (ref) {
        (0, react_1.useEffect)(function () {
            function handleOutsideClick(e) {
                if (ref.current && !ref.current.contains(e.target)) {
                    if (opened) {
                        setOpened(false);
                    }
                }
            }
            document.addEventListener('mousedown', handleOutsideClick);
            return function () { return document.removeEventListener('mousedown', handleOutsideClick); };
        }, [ref]);
    };
    var _handleClick = function (e) {
        setOpened(!opened);
        lftClick && lftClick(e);
    };
    var _handleChange = function (e) {
        setIndex(e.currentIndex ? e.currentIndex : 0);
        lftChange && lftChange(e);
        handleBlur();
    };
    var selectedText = index !== null && children ? (_c = (_b = children[index]) === null || _b === void 0 ? void 0 : _b.props) === null || _c === void 0 ? void 0 : _c.children : placeholder;
    (0, react_1.useEffect)(function () {
        if (escapePress) {
            setOpened(false);
        }
    }, [escapePress]);
    _handleClickOutside(selectBox);
    (0, react_1.useEffect)(function () { }, [opened]);
    if (dataElement) {
        if (dataElement.includes('_')) {
            if (typeof window !== 'undefined' &&
                (((_d = window.location.href) === null || _d === void 0 ? void 0 : _d.indexOf('localhost')) > -1 || ((_e = window.location.href) === null || _e === void 0 ? void 0 : _e.indexOf('dev')) > -1)) {
                console.warn('Não é necessário mais colocar o prefixo no atributo dataElement');
            }
        }
        else {
            dataElement = "select_" + dataElement;
        }
    }
    return ((0, jsx_runtime_1.jsxs)(S.Wrapper, __assign({ bgColor: bgColor, "data-lift": "lft-input", disabled: disabled, helper: helper, id: id, opened: opened, ref: selectBox, status: status }, { children: [(0, jsx_runtime_1.jsxs)(S.Select, __assign({ "aria-labelledby": id && id + "_label", bgColor: bgColor, "data-element": dataElement, "data-info": dataInfo, "data-lift": "lft-input-select", "data-testid": dataTestId ? dataTestId : id && id, helper: helper, name: name, opened: opened, tabIndex: disabled ? -1 : tabIndex, onBlur: function () { return handleBlur(); }, onClick: _handleClick, onFocus: handleFocus, type: "button" }, { children: [!!label && ((0, jsx_runtime_1.jsx)(S.Label, __assign({ "aria-label": label + ", " + selectedText + ", " + (opened ? 'Clique para fechar o Seletor' : 'Clique para abrir o seletor'), id: id + "_label", htmlFor: id, title: label, bgColor: bgColor }, { children: label }), void 0)), (0, jsx_runtime_1.jsx)(S.Placeholder, __assign({ className: "" + (index !== null ? 'selected-value' : '') }, { children: selectedText }), void 0), (0, jsx_runtime_1.jsx)(LftIconBase_1.default, { ariaHidden: true, icon: opened ? chevron_up_1.default : chevron_down_1.default, size: "md" }, void 0), (0, jsx_runtime_1.jsx)(LftListMenu_1.default, __assign({ visible: opened, lftChange: function (e) { return _handleChange(e); } }, { children: children }), void 0)] }), void 0), !disabled && !opened && helper && (0, jsx_runtime_1.jsx)(LftHelper_1.default, { content: helperText, name: name, status: status }, void 0)] }), void 0));
};
exports.default = LftInputSelect;
